import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getProfile,
  updateProfile,
  getAddress,
  updateAddress,
  updatePassword,
} from '../services/profile';

export const useProfile = () => {
  const queryClient = useQueryClient();

  const { data: profile, isLoading: isLoadingProfile } = useQuery({
    queryKey: ['profile'],
    queryFn: getProfile,
  });

  const { data: address, isLoading: isLoadingAddress } = useQuery({
    queryKey: ['address'],
    queryFn: getAddress,
  });

  const mutationProfile = useMutation({
    mutationFn: updateProfile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] });
    },
  });

  const mutationAddress = useMutation({
    mutationFn: updateAddress,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['address'] });
    },
  });

  const mutationPassword = useMutation({
    mutationFn: updatePassword,
    onSuccess: () => {
      // Password updated successfully
    },
    onError: (error) => {
      console.error('Password update failed:', error);
    },
  });

  return {
    profile,
    address,
    isLoading: isLoadingProfile || isLoadingAddress,
    updateProfile: mutationProfile.mutate,
    updateProfileAsync: mutationProfile.mutateAsync,
    updateAddress: mutationAddress.mutate,
    updateAddressAsync: mutationAddress.mutateAsync,
    updatePassword: mutationPassword.mutate,
    passwordUpdateLoading: mutationPassword.isPending,
    passwordUpdateError: mutationPassword.error,
  };
};
